import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enderecoImovel', standalone: true })
export class EnderecoImovelPipe implements PipeTransform {
   transform(imovel: any): string {
      const esconderCidadeEEstado = imovel.endereco_cidade === 'Santa Maria';
      const cidade = esconderCidadeEEstado ? '' : imovel.endereco_cidade;
      const estado = esconderCidadeEEstado ? '' : imovel.endereco_estado;

      if (imovel.endereco_logradouro_visivel) {
         return `${imovel.endereco_logradouro}, ${imovel.endereco_bairro}${cidade ? ' - ' + cidade : ''}${
            estado ? ', ' + estado : ''
         }`;
      }

      if (imovel.endereco_bairro_visivel) {
         return `${imovel.endereco_bairro}${cidade ? ' - ' + cidade : ''}${estado ? ', ' + estado : ''}`;
      }

      return [cidade, estado].filter(Boolean).join(', ');
   }
}
